import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Quotations from "@/pages/Quotations";
import Vendors from "@/pages/Vendors";
import Items from "@/pages/Items";
import Clients from "@/pages/Clients";
import Orders from "@/pages/Orders";
import ClientQuotations from "@/pages/ClientQuotations";
import Reports from "@/pages/Reports";
import Users from "@/pages/Users";
import CompanySettings from "@/pages/CompanySettings";
import AuditLog from "@/pages/AuditLog";
import { Toaster } from "sonner";

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <Toaster position="top-right" richColors />
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
                    <Route path="/projects" element={<ProtectedRoute><Layout><Projects /></Layout></ProtectedRoute>} />
                    <Route path="/projects/:id" element={<ProtectedRoute><Layout><ProjectDetail /></Layout></ProtectedRoute>} />
                    <Route path="/quotations" element={<ProtectedRoute><Layout><Quotations /></Layout></ProtectedRoute>} />
                    <Route path="/vendors" element={<ProtectedRoute><Layout><Vendors /></Layout></ProtectedRoute>} />
                    <Route path="/items" element={<ProtectedRoute><Layout><Items /></Layout></ProtectedRoute>} />
                    <Route path="/clients" element={<ProtectedRoute><Layout><Clients /></Layout></ProtectedRoute>} />
                    <Route path="/orders" element={<ProtectedRoute><Layout><Orders /></Layout></ProtectedRoute>} />
                    <Route path="/client-quotations" element={<ProtectedRoute><Layout><ClientQuotations /></Layout></ProtectedRoute>} />
                    <Route path="/reports" element={<ProtectedRoute perm="report.view"><Layout><Reports /></Layout></ProtectedRoute>} />
                    <Route path="/users" element={<ProtectedRoute perm="user.manage"><Layout><Users /></Layout></ProtectedRoute>} />
                    <Route path="/audit" element={<ProtectedRoute perm="audit.view"><Layout><AuditLog /></Layout></ProtectedRoute>} />
                    <Route path="/settings" element={<ProtectedRoute perm="company.settings"><Layout><CompanySettings /></Layout></ProtectedRoute>} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;
